export default {
      id: "zoom-search-usage",
      viewBox: "0 0 11.782 11.781",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#zoom-search",
      toString: function () {
        return this.url;
      }
    }